import { render, staticRenderFns } from "./ReloadDialog.vue?vue&type=template&id=c0997896"
import script from "./ReloadDialog.vue?vue&type=script&lang=js"
export * from "./ReloadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports